// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { waveform16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-waveform': IconWaveform;
    }
}

/**
 * The icon component for the 'waveform' icon
 */
export class IconWaveform extends Icon {
    public constructor() {
        super(waveform16X16);
    }
}

registerIcon('icon-waveform', IconWaveform);
export const iconWaveformTag = 'nimble-icon-waveform';
